import apiClient from '../api';

export interface UserProfile {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  displayName: string;
  role: 'Bodybuilder' | 'Coach';
  isCoach: boolean;
  createdAt: string;
  lastLoginAt?: string;
}

const userService = {
  /**
   * Fetches the current user's profile from the backend.
   * If this is the user's first login, the backend will auto-provision their account.
   * Called once on app startup after authentication.
   */
  getOrCreateCurrentUser: async (): Promise<UserProfile> => {
    const response = await apiClient.get<UserProfile>('/users/me');
    return response.data;
  },

  /**
   * Updates the current user's display name or other mutable profile fields.
   */
  updateProfile: async (updates: { displayName?: string; email?: string }): Promise<UserProfile> => {
    const response = await apiClient.put<UserProfile>('/users/me', updates);
    return response.data;
  },
};

export default userService;
